import { useState } from 'react';
import { toneOptionsForFamily } from '../character/manifest';
import type { CharacterAppearance } from '../types';
import CharacterArtThumbnail from './CharacterArtThumbnail';

function appearance(tone: string): CharacterAppearance {
  return {
    species: 'Owl',
    furTone: tone,
    outfit: 'Default body',
    headwear: 'None',
    eyewear: 'None',
    audio: 'None',
    jewelry: 'None',
    prop: 'None',
    device: 'Phone',
    idlePersonality: 'Composed',
    animationSpeed: 1,
  };
}

export default function OwlApprovalSheet() {
  const [open, setOpen] = useState(false);
  const tones = toneOptionsForFamily('owl');

  return (
    <section className="owl-approval-sheet">
      <div className="owl-approval-head">
        <div>
          <div className="eyebrow">OWL APPROVAL SHEET</div>
          <h3>Approved Owl base-art QA</h3>
          <p className="muted">
            Clothing and visual gender variants stay out until bespoke Owl art is approved.
          </p>
        </div>
        <button
          type="button"
          className="secondary-action"
          onClick={() => setOpen(value => !value)}
        >
          {open ? 'Close sheet' : 'Open sheet'}
        </button>
      </div>

      {open && (
        <div className="owl-approval-content">
          <div className="approval-section">
            <div className="approval-section-title">
              <strong>Approved body</strong>
              <span>Exact owner-approved proportions, no clothing overlay</span>
            </div>
            <div className="approval-pair-grid">
              <CharacterArtThumbnail
                baseType="library_animal"
                appearance={appearance('Natural')}
                label="Approved Owl"
              />
            </div>
          </div>

          <div className="approval-section">
            <div className="approval-section-title">
              <strong>Every feather tone</strong>
              <span>Base body only</span>
            </div>
            <div className="approval-table">
              {tones.map(tone => (
                <div className="approval-row" key={tone}>
                  <strong>{tone}</strong>
                  <div className="approval-pair-grid">
                    <CharacterArtThumbnail
                      baseType="library_animal"
                      appearance={appearance(tone)}
                      label={tone}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
